// extracted by mini-css-extract-plugin
module.exports = {"section":"SummaryAndActions_section__3KfHh","summary":"SummaryAndActions_summary__3T9-M","fadeIn":"SummaryAndActions_fadeIn__1DD5U","fadeOut":"SummaryAndActions_fadeOut__2lv3U"};